import React, { Component } from 'react';
import './style.scss';

class Spiner extends Component {
  render() {
    return (
      <div className="Spiner">
        <div>
          <div className="loader">Loading...</div>  
        </div>
      </div>
    );
  }
}

export default Spiner;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Spiner/Spiner.jsx